import React, { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon, PhoneIcon, MailIcon } from 'lucide-react';
import { site } from '../data/site';
const nav = [{
  to: '/',
  label: 'Home'
}, {
  to: '/services',
  label: 'Services'
}, {
  to: '/service-area',
  label: 'Service Area'
}, {
  to: '/about',
  label: 'About'
}, {
  to: '/specials',
  label: 'Specials & Tips'
}, {
  to: '/contact',
  label: 'Contact'
}];
export function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  React.useEffect(() => {
    setOpen(false);
  }, [location.pathname]);
  return <header className="sticky top-0 z-50 w-full" data-id="element-168" data-mp="31cgz8hfh363b">
      <div className="hidden bg-ink text-steel-200 md:block" data-id="element-169" data-mp="36as9uudldkml">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-6 py-2 text-xs" data-id="element-170" data-mp="36aa1izdnnfyb">
          <p className="font-medium uppercase tracking-widest text-steel-300" data-id="element-171" data-mp="3b81ulwq1d843">
            Licensed &amp; Insured Builder · Lead Safe EPA Certified · BBB Member
          </p>
          <div className="flex items-center gap-5" data-id="element-172" data-mp="2wlm89d2q82jd">
            <a href={site.emailHref} className="flex items-center gap-1.5 transition hover:text-white" data-id="element-173" data-mp="2rm18x1jn9s64">
              <MailIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-174" data-mp="2mngb18rv7kku" />
              {site.email}
            </a>
            <a href={site.plumbingPhone.href} className="flex items-center gap-1.5 transition hover:text-white" data-id="element-175" data-mp="2hpepmh6yv967">
              <PhoneIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-176" data-mp="3abpqzu2ede42" />
              Plumbing: {site.plumbingPhone.display}
            </a>
          </div>
        </div>
      </div>

      <div className="border-b border-steel-200 bg-white" data-id="element-177" data-mp="30mfve48chdb7">
        <div className="mx-auto flex h-[68px] max-w-7xl items-center justify-between gap-2 px-3 sm:h-auto sm:gap-4 sm:px-6 sm:py-3" data-id="element-178" data-mp="30lwnlgces5aw">
          <Link to="/" className="flex min-w-0 items-center gap-2 sm:gap-3" data-id="element-179" data-mp="3tb3nojrih2y9">
            <img src={site.logo} alt="TOTAL Home Improvement logo" className="h-9 w-auto shrink-0 sm:h-11" data-id="element-180" data-mp="3t90n55sqfrfa" />
            <span className="font-display text-base font-bold uppercase leading-none tracking-tight text-ink sm:text-xl" data-id="element-181" data-mp="1wbmm0zso7d9x">
              TOTAL Home
              <span className="block text-[0.8em] text-safety sm:text-[1em]" data-id="element-182" data-mp="1hlxfsq5q0j2s">
                Improvement
              </span>
            </span>
          </Link>

          <nav className="hidden items-center gap-1 lg:flex" aria-label="Primary" data-id="element-183" data-mp="18magc9wjxncd">
            {nav.map(item => <NavLink key={item.to} to={item.to} end={item.to === '/'} className={({
            isActive
          }) => `rounded-sm px-3 py-2 text-sm font-semibold uppercase tracking-wide transition ${isActive ? 'text-safety' : 'text-ink-700 hover:bg-steel-100 hover:text-ink'}`} data-id="element-184" data-mp="yp5opujxszo6">
                {item.label}
              </NavLink>)}
          </nav>

          <div className="flex shrink-0 items-center gap-2" data-id="element-185" data-mp="hgwcu7xpzng6">
            <a href={site.estimatePhone.href} aria-label={`Call ${site.estimatePhone.display}`} className="flex items-center gap-2 rounded-sm bg-safety px-3 py-2.5 text-sm font-bold text-white transition hover:bg-safety-600 sm:hidden" data-id="element-186" data-mp="w47sakx0vrlk">
              <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-187" data-mp="106beo4l8cglm" />
              <span className="hidden xs:inline" data-id="element-188" data-mp="105t6qap7gdxv">Call</span>
            </a>
            <a href={site.estimatePhone.href} className="hidden items-center gap-2 rounded-sm border-2 border-ink px-3 py-2 text-sm font-bold text-ink transition hover:bg-ink hover:text-white sm:flex" data-id="element-189" data-mp="1f20ufkztnxhw">
              <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-190" data-mp="3gwjjdavkah2t" />
              {site.estimatePhone.display}
            </a>
            <Link to="/contact" className="hidden rounded-sm bg-safety px-4 py-2.5 text-sm font-bold uppercase tracking-wide text-white transition hover:bg-safety-600 md:block" data-id="element-191" data-mp="22z6vwhox4hia">
              Free Estimate
            </Link>
            <button type="button" onClick={() => setOpen(v => !v)} className="rounded-sm border border-steel-300 p-2 text-ink lg:hidden" aria-expanded={open} aria-label={open ? 'Close menu' : 'Open menu'} data-id="element-192" data-mp="2cv0fgl121b9k">
              {open ? <XIcon className="h-6 w-6" data-id="element-193" data-mp="1t9442ktj99lj" /> : <MenuIcon className="h-6 w-6" data-id="element-194" data-mp="1t7knsu7vmyjr" />}
            </button>
          </div>
        </div>

        {open && <nav className="border-t border-steel-200 bg-white lg:hidden" aria-label="Mobile" data-id="element-195" data-mp="11hxz9r2vanpx">
            <ul className="mx-auto max-w-7xl px-4 py-2 sm:px-6" data-id="element-196" data-mp="15i8430exb837">
              {nav.map(item => <li key={item.to} data-id="element-197" data-mp="xypgshyncsot">
                  <NavLink to={item.to} end={item.to === '/'} className={({
              isActive
            }) => `block border-b border-steel-100 py-3.5 text-base font-semibold uppercase tracking-wide ${isActive ? 'text-safety' : 'text-ink'}`} data-id="element-198" data-mp="xxo305q8xs3e">
                    {item.label}
                  </NavLink>
                </li>)}
              <li className="space-y-2 py-4" data-id="element-199" data-mp="a8v2rx2lcy2z">
                <Link to="/contact" className="block rounded-sm bg-safety px-4 py-3.5 text-center text-base font-bold uppercase tracking-wide text-white" data-id="element-200" data-mp="5al7lmgv9xhd">
                  Request a Free Estimate
                </Link>
                <a href={site.estimatePhone.href} className="flex items-center justify-center gap-2 rounded-sm bg-ink px-4 py-3.5 text-base font-bold text-white" data-id="element-201" data-mp="3shn7hsoiby34">
                  <PhoneIcon className="h-5 w-5 text-safety" aria-hidden="true" data-id="element-202" data-mp="3irx4uh5b05ym" />
                  {site.estimatePhone.display}
                  <span className="text-xs font-medium uppercase tracking-wide text-steel-300" data-id="element-203" data-mp="33vzddc6brpsq">
                    Estimates
                  </span>
                </a>
                <a href={site.plumbingPhone.href} className="flex items-center justify-center gap-2 rounded-sm border-2 border-ink px-4 py-3.5 text-base font-bold text-ink" data-id="element-204" data-mp="eh5x5ugsksu">
                  <PhoneIcon className="h-5 w-5 text-safety" aria-hidden="true" data-id="element-205" data-mp="3msqsraiqxkri" />
                  {site.plumbingPhone.display}
                  <span className="text-xs font-medium uppercase tracking-wide text-steel-500" data-id="element-206" data-mp="3rr22ll91jv9q">
                    Plumbing
                  </span>
                </a>
                <a href={site.emailHref} className="flex items-center justify-center gap-2 break-all rounded-sm border border-steel-300 px-4 py-3.5 text-sm font-semibold text-ink" data-id="element-207" data-mp="o4tln2vybltz">
                  <MailIcon className="h-4 w-4 text-safety" aria-hidden="true" data-id="element-208" data-mp="23uu9t11h5lmj" />
                  {site.email}
                </a>
              </li>
            </ul>
          </nav>}
      </div>
      <div className="hatch h-1.5 w-full" aria-hidden="true" data-id="element-209" data-mp="2dlp2oo987jgy" />
    </header>;
}